import { OpenPositionItem } from "./openPositionsSlice"

export function fetchOpenPositions(endpoint: string) {
  return new Promise<{ data: Array<OpenPositionItem> }>((resolve, reject) => {
    fetch(endpoint)
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            /*const duplicates = data //TESTS ONLY
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
              .concat(data)
            resolve({ data: duplicates })*/
            resolve({ data })
          })
        } else {
          reject(response)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}
